module.exports = __webpack_public_path__ + "static/img/product-kegel.a9888f59.png";